package com.merkost.handpass.admin.contract

import com.merkost.handpass.api.dto.admin.AdminImageListItem
import com.merkost.handpass.api.enums.ImageStatus
import pro.respawn.flowmvi.api.MVIAction
import pro.respawn.flowmvi.api.MVIIntent
import pro.respawn.flowmvi.api.MVIState

data class ImagesState(
    val images: AsyncSection<List<AdminImageListItem>> = AsyncSection.Loading,
    val statusFilter: ImageStatus? = null,
    val pendingIds: Set<String> = emptySet(),
) : MVIState

sealed interface ImagesIntent : MVIIntent {
    data object Refresh : ImagesIntent
    data class ReactToFocusTick(val tick: Long) : ImagesIntent
    data class SetFilter(val status: ImageStatus?) : ImagesIntent
    data class Approve(val id: String) : ImagesIntent
    data class Reject(val id: String) : ImagesIntent
}

sealed interface ImagesAction : MVIAction {
    data class Navigate(val path: String) : ImagesAction
}
